import {createContext, useContext, useState, useCallback} from "react";

// NavContext държи само динамични „маркери" по локални табове (напр. В3 —
// бледо червен таб „Други площи" при въведена корекция). Ключът е `tab.key`
// от navConfig.js. Стойност: {tone, title} или null за махане.
export const NavContext = createContext();

export const NavProvider = ({children}) => {
    const [tabMarkers, setTabMarkers] = useState({});

    const setTabMarker = useCallback((key, value) => {
        setTabMarkers(prev => {
            if (value == null) {
                if (!(key in prev)) return prev;
                const next = {...prev};
                delete next[key];
                return next;
            }
            if (prev[key] && prev[key].tone === value.tone && prev[key].title === value.title) {
                return prev;
            }
            return {...prev, [key]: value};
        });
    }, []);

    return (
        <NavContext.Provider value={{tabMarkers, setTabMarker}}>
            {children}
        </NavContext.Provider>
    );
};

export const useNavContext = () => useContext(NavContext);
